module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/redzel.307b1b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/redzel.jpg
// module id = XACR
// module chunks = 0